module.exports = __webpack_public_path__ + "static/media/DSC_9155-HDR.863dce3e.jpg";